import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { sendGAEvent, sendGAPageview } from '../utils/gaConsent';

export function useViewChangeTracker(
  tableView: string,
  identifier: string,
  viewType = 'table',
  isUserUnauth = false,
) {
  const location = useLocation();
  const bubbleIdentifiers = ['ALL', 'VDA', 'GDA', 'DDA'];
  const menuIdentifiers = ['DISEASES', 'VARIANTS', 'GENES', 'DRUGS'];

  useEffect(() => {
    const ident = bubbleIdentifiers.includes(identifier) ? 'BOLAS' : 'MENU';
    let eventLabel: string;

    if (menuIdentifiers.includes(identifier)) {
      eventLabel = `${tableView} - ${ident} (${identifier})`;
    } else {
      eventLabel = `${tableView} - ${ident}`;
    }

    if (isUserUnauth) eventLabel += ' /examples';

    sendGAEvent({
      category: `${viewType}_view`,
      action: `view_${viewType}`,
      label: eventLabel,
    });

    sendGAPageview({
      hitType: 'pageview',
      page: '/search',
      title: 'Search',
    });
  }, [location.pathname, tableView, identifier, viewType, isUserUnauth]);

  return '';
}
